import { jsx as r, jsxs as c, Fragment as _ } from "react/jsx-runtime";
import s from "classnames";
import "../../fields/FieldContainer/index.js";
import f from "../../fields/Checkbox/index.js";
import "../../fields/ContentEditable/index.js";
import "../../fields/DateInput/index.js";
import "date-fns";
import "react";
import "react-i18next";
import "../../index-YV3Z4nmr.js";
import "reactjs-popup";
import "../../components/ThemeContext/index.js";
import "../../components/Button/index.js";
import "../../components/Modal/index.js";
import "react-dropzone";
import "../../components/Breadcrumbs/index.js";
import { Grid as g, GridItem as a } from "../../components/Grid/index.js";
import "react-hook-form";
import "sanitize-html";
import "i18next";
import "@dnd-kit/core";
import "@dnd-kit/sortable";
import "react-number-format";
import "immutability-helper";
import "../../fields/Input/index.js";
import "../../components/Tooltip/index.js";
import "react-dom";
import "../../fields/InputTooltip/index.js";
import "../../fields/PhoneInput/index.js";
import "../../fields/SocialSelect/index.js";
import "../../fields/Switcher/index.js";
import "../../fields/Textarea/index.js";
const h = "forma-ui__activities-grid__list", u = "forma-ui__activities-grid__item", v = "forma-ui__activities-grid__selected", b = "forma-ui__activities-grid__label", N = "forma-ui__activities-grid__name", x = "forma-ui__activities-grid__description", C = "forma-ui__activities-grid__icon", t = {
  list: h,
  item: u,
  selected: v,
  label: b,
  name: N,
  description: x,
  icon: C
}, ti = ({ items: o, selected: e, onSelect: l }) => /* @__PURE__ */ r(g, { className: t.list, columns: 3, children: o != null && o.length ? o.map(({ id: i, description: n, name: m, iconUrl: p }) => /* @__PURE__ */ r(a, { children: /* @__PURE__ */ r(
  f,
  {
    id: i,
    name: i,
    label: /* @__PURE__ */ c(_, { children: [
      /* @__PURE__ */ r("img", { className: t.icon, src: p, alt: m }),
      /* @__PURE__ */ c("div", { className: t.content, children: [
        /* @__PURE__ */ r("div", { className: t.name, children: m }),
        /* @__PURE__ */ r("div", { className: t.description, children: n })
      ] })
    ] }),
    containerClass: s(t.item, e.includes(i) && t.selected),
    labelClass: t.label,
    checked: e.includes(i),
    onChange: (d) => l(i, d.target.checked)
  }
) }, i)) : [...Array(12)].map((i) => /* @__PURE__ */ r(a, { children: /* @__PURE__ */ r("div", { className: s(t.item, "skeleton-loader") }, i) }, i)) });
export {
  ti as default
};
